// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__CEPwS","buttons":"PendingPaymentAlert_buttons__3pU6T"};